/** Contains type alias and definitions related to Galaxy API models. */
/**
 * Returns true if the given entry is a top level HDCA and false for sub-collections.
 */
export function isHDCA(entry) {
    return (entry !== undefined && "history_content_type" in entry && entry.history_content_type === "dataset_collection");
}
/**
 * Returns true if the given element of a collection is a DatasetCollection.
 */
export function isCollectionElement(element) {
    return element.element_type === "dataset_collection";
}
/**
 * Returns true if the given dataset entry is an instance of DatasetDetails.
 */
export function hasDetails(entry) {
    return "peek" in entry;
}
export function isInaccessible(entry) {
    return "accessible" in entry && !entry.accessible;
}
export function isHistorySummary(history) {
    return !("user_id" in history);
}
export function isHistorySummaryExtended(history) {
    return "contents_active" in history && "user_id" in history;
}
export function isRegisteredUser(user) {
    return user !== null && !(user === null || user === void 0 ? void 0 : user.isAnonymous);
}
export function isAnonymousUser(user) {
    return user !== null && user.isAnonymous;
}
export function userOwnsHistory(user, history) {
    return (
    // Assuming histories without user_id are owned by the current user
    (isRegisteredUser(user) && !hasOwner(history)) ||
        (isRegisteredUser(user) && hasOwner(history) && user.id === history.user_id) ||
        (isAnonymousUser(user) && hasAnonymousOwner(history)));
}
function hasOwner(history) {
    return "user_id" in history && history.user_id !== null;
}
function hasAnonymousOwner(history) {
    return "user_id" in history && history.user_id === null;
}
